import { render, staticRenderFns } from "./PrizeWinners.vue?vue&type=template&id=7d6b3160"
import script from "./PrizeWinners.vue?vue&type=script&lang=js"
export * from "./PrizeWinners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports